import { render, staticRenderFns } from "./SalesRankingTable.vue?vue&type=template&id=3daf1c1a&scoped=true"
import script from "./SalesRankingTable.vue?vue&type=script&lang=js"
export * from "./SalesRankingTable.vue?vue&type=script&lang=js"
import style0 from "./SalesRankingTable.vue?vue&type=style&index=0&id=3daf1c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daf1c1a",
  null
  
)

export default component.exports